// `generateMenuStructure` produce items `(MenuItem | false)[]` (gating por
// rol/vendor), así que el filtro acepta y descarta los falsy.
export interface FilterableItem {
  children: string;
}

export interface FilterableSection<T extends FilterableItem> {
  id: string;
  heading?: string;
  items: (T | false)[];
}

export interface FilteredSection<T extends FilterableItem> {
  id: string;
  heading?: string;
  items: T[];
}

export const normalizeText = (value: string): string =>
  value
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .trim();

export function filterSections<T extends FilterableItem>(
  sections: FilterableSection<T>[],
  query: string
): FilteredSection<T>[] {
  const normalizedQuery = normalizeText(query);

  return sections
    .map((section) => ({
      id: section.id,
      heading: section.heading,
      items: section.items.filter(
        (item): item is T =>
          Boolean(item) &&
          (!normalizedQuery ||
            normalizeText((item as T).children).includes(normalizedQuery))
      )
    }))
    .filter((section) => section.items.length > 0);
}
